import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DeviceLogsComponent } from "./device-logs/device-logs.component";

const routes: Routes = [
	{
		path: "",
		component: DeviceLogsComponent,
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class DeviceLogsRoutingModule {}
